"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const classnames_1 = __importDefault(require("classnames"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const Check_1 = __importDefault(require("@mui/icons-material/Check"));
const ProfileAvatar_1 = __importDefault(require("containers/App/Header/ProfileMenu/ProfileAvatar"));
const SubscriptionAlert_1 = __importDefault(require("containers/ProfilePage/SubscriptionAlert"));
const warning_svg_1 = __importDefault(require("assets/warning.svg"));
const styles_1 = require("./styles");
const useStyle = (0, mui_1.makeStyles)()(styles_1.styles);
const MiniDatasetPicker = ({ dataset, ownDatasets, sharedDatasets, entitledDatasets, subscription, label = 'CHANGE', labelStyle, onChange, id, }) => {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const { classes } = useStyle();
    const handleClick = (0, react_1.useCallback)((event) => {
        setAnchorEl(event.currentTarget);
    }, []);
    const handleMenuItemClick = (0, react_1.useCallback)((selectedDataset) => {
        setAnchorEl(null);
        if (onChange && selectedDataset) {
            onChange(selectedDataset);
        }
    }, [onChange]);
    const handleClose = (0, react_1.useCallback)(() => {
        setAnchorEl(null);
    }, []);
    const renderDatasets = (0, react_1.useCallback)((theDataset, index, selectedDataset, ownDataset = false) => {
        const hasValidEntitlement = entitledDatasets.get(theDataset.id);
        const noDatasetOrEntitlement = !ownDataset && !hasValidEntitlement;
        const isDisabled = noDatasetOrEntitlement || (ownDataset && !(subscription === null || subscription === void 0 ? void 0 : subscription.active));
        return (<MenuItem_1.default key={theDataset.id} selected={selectedDataset === theDataset} onClick={() => handleMenuItemClick(theDataset)} disabled={isDisabled} sx={{
                '&.Mui-disabled': {
                    opacity: 1,
                },
                '&.Mui-selected': {
                    backgroundColor: 'transparent',
                },
                '&.Mui-selected:hover': {
                    backgroundColor: ({ palette }) => palette.state.hover.default,
                },
                '&:hover': {
                    backgroundColor: ({ palette }) => palette.state.hover.default,
                },
            }}>
        <ListItemIcon_1.default sx={{
                visibility: selectedDataset === theDataset || noDatasetOrEntitlement ? 'visible' : 'hidden',
                marginRight: 0,
            }}>
          {noDatasetOrEntitlement ? (<img src={warning_svg_1.default} alt="alert" height={24} width={24}/>) : (<Check_1.default />)}
        </ListItemIcon_1.default>
        <ListItemText_1.default sx={{
                opacity: isDisabled ? 0.5 : 1,
            }} primary={<div className={(0, classnames_1.default)(classes.textEllipsis, classes.datasetNameWrapper)}>
              {theDataset.name}
            </div>} secondary={ownDataset
                ? null
                : noDatasetOrEntitlement && (<Typography_1.default variant="caption" className={classes.ownerName}>
                  (Owner subscription expired)
                </Typography_1.default>)} id={index === 0 ? 'my-account-1st-data-set' : ''}/>
        {ownDataset && <ProfileAvatar_1.default datasetId={theDataset.id}/>}
      </MenuItem_1.default>);
    }, [entitledDatasets, subscription, handleMenuItemClick, classes]);
    return (<>
      <Button_1.default classes={labelStyle || { label: classes.labelStyle }} aria-owns={anchorEl ? 'dataset-menu' : undefined} aria-haspopup="true" onClick={handleClick} sx={{
            height: '100%',
            textTransform: 'none',
            fontSize: 16,
        }} id={id}>
        {label}
      </Button_1.default>
      <Menu_1.default id="dataset-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} sx={{ zIndex: 1302 }} slotProps={{ paper: { sx: { backgroundColor: ({ palette }) => palette.surface.overlay } } }}>
        {ownDatasets.size > 0 && (<Typography_1.default color="inherit" variant="subtitle1" className={classes.datasetTitle}>
            My Cloud Accounts
          </Typography_1.default>)}

        {subscription !== null && !subscription.active && (<SubscriptionAlert_1.default alertClass={classes.alert} label="Subscription expired. Shared Cloud Accounts are still available."/>)}

        {Array.from(ownDatasets.values()).map((theDataset, index) => renderDatasets(theDataset, index, dataset, true))}

        {sharedDatasets.size > 0 && (<>
            <Typography_1.default color="inherit" variant="subtitle1" className={classes.datasetTitle}>
              Shared with me
            </Typography_1.default>
            {Array.from(sharedDatasets.values()).map((theDataset, index) => renderDatasets(theDataset, index, dataset, false))}
          </>)}
      </Menu_1.default>
    </>);
};
exports.default = MiniDatasetPicker;
